import { useState, useEffect, useCallback } from 'react';
import { siteCountService } from '../services/siteCountService';

export const useSiteCount = (organizationId) => {
  const [siteCount, setSiteCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchSiteCount = useCallback(async () => {
    if (!organizationId) {
      setSiteCount(0);
      return;
    }
    
    setLoading(true);
    try {
      const count = await siteCountService.getSiteCountForOrganization(organizationId);
      setSiteCount(count);
    } catch (error) {
      console.error("Error fetching site count:", error);
      setSiteCount(0);
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    fetchSiteCount();
  }, [fetchSiteCount]);

  return { siteCount, loading, refetch: fetchSiteCount };
};

export const useBatchSiteCounts = (organizationIds) => {
  const [siteCounts, setSiteCounts] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchSiteCounts = useCallback(async () => {
    if (!organizationIds || organizationIds.length === 0) {
      setSiteCounts({});
      return;
    }
    
    setLoading(true);
    try {
      const counts = await siteCountService.batchGetSiteCounts(organizationIds);
      setSiteCounts(counts);
    } catch (error) {
      console.error("Error batch fetching site counts:", error);
      setSiteCounts({});
    } finally {
      setLoading(false);
    }
  }, [organizationIds]);

  useEffect(() => {
    fetchSiteCounts();
  }, [fetchSiteCounts]);

  return { siteCounts, loading, refetch: fetchSiteCounts };
};